import { Injectable, inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CheckoutService } from './checkout.service';

@Injectable({
  providedIn: 'root',
})
export class CheckoutGuardService {
  private router = inject(Router);
  private checkoutService = inject(CheckoutService);

  basketUrl = `/${environment.urls.basket}`;

  canActivateChild(): boolean {
    if (!this.checkoutService.isCheckingOut) {
      this.router.navigate([this.basketUrl]);

      return false;
    }

    return true;
  }
}

export const CheckoutGuard: CanActivateChildFn = (): boolean => {
  return inject(CheckoutGuardService).canActivateChild();
};
